<template>
  <div class="htfbmenu between">
    <div class="menuitem  center" v-for="(item,index) in list">
    	<div class="flex-col text_center  text">
    		<span class="FontBlack " style="font-weight: 500;">{{item.name}}</span>
			<span class="FontSize16 FontGray1 mt10">{{item.info}}</span>
    	</div>
		<div class="img flex center">
			<img :src="item.src" >
		</div>
    </div>
    
  </div>
</template>

<script>
export default {
  data: () => ({
   list:[
	   {name:'合同代写',info:'降低90%常见风险的专业合同',src:require('../../../assets/contmodeldet/icon1.png')},
	   {name:'合同审核',info:'敬请期待',src:require('../../../assets/contmodeldet/icon2.png')},
	   {name:'找律师',info:'找到适合的律师进行法律咨询',src:require('../../../assets/contmodeldet/icon3.png')},
	   {name:'律所库',info:'为您挑选适合的律所解决您的法律问题',src:require('../../../assets/contmodeldet/icon4.png')},
	   ]
  }),
  created() {
  	
  },
  methods: {
    
    
  },
};
</script>

<style lang="scss" scoped>
.htfbmenu {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  align-items: flex-start;
  .menuitem{
	  width: 278px;
	  height: 170px;
	  padding: 44px 1px;
	  background: #FFFFFF;
	  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
	  border-radius: 10px;
	  .text{
		  width: 53%;
		  font-size: 24px;
	  }
	  .img{
		  width: 82px;
		  height: 83px;
		  background: #F3F7FA;
		  border-radius: 50%;
		  margin-left: 15px;
		  img{
			  object-fit: cover;
		  }
	  }
  }
}
</style>